import { endpoints } from "config";

export const META_TITLE = "Gatorade Teamzone by Gatorade";
export const META_DESCRIPTION =
  "Gatorade Teamzone delivers sport drinks for your team";
export const CANONICAL_URL_BASE = endpoints.web;
export const META_DEFAULT_OG_IMAGE = `${endpoints.cdn}/static-images/gatorade-icons/gatorade-team-zone.jpg`;
export const PRIMARY_COLOR = `#fa5000`;
